import { render, staticRenderFns } from "./ListConfigCuentas.vue?vue&type=template&id=80aa7276&scoped=true&"
import script from "./ListConfigCuentas.vue?vue&type=script&lang=js&"
export * from "./ListConfigCuentas.vue?vue&type=script&lang=js&"
import style0 from "./ListConfigCuentas.vue?vue&type=style&index=0&id=80aa7276&lang=scss&scoped=true&"
import style1 from "./ListConfigCuentas.vue?vue&type=style&index=1&id=80aa7276&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aa7276",
  null
  
)

export default component.exports